<template>
  <div :id="'msg-' + id" class="flex content-end" :class="reply ? 'justify-start' : 'justify-end'">
    <div class="chat-bubble p-1 pr-2 pl-2 m-1 rounded-lg w-fit"
      :class="reply ? 'text-left bg-secondary mr-10' : 'text-right bg-primary text-white ml-10'" v-html="escapedMsg">
    </div>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  id: number
  msg: string
  reply?: boolean
}>()

const escapedMsg = computed(() => escape(props.msg))

const escape = (text: string) => {
  while (text.length > 0 && text.endsWith('\n')) {
    text = text.slice(0, -1)
  }
  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>')
}

</script>